import { SxProps, Theme } from '@mui/material';

export const drawerSx: SxProps<Theme> = {
  width: 224,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 224,
    padding: '9px 0',
    boxSizing: 'border-box',
    borderRadius: 0,
    borderRight: '1px solid rgba(0,0,0,0.06)',
    borderBottom: '1px solid rgba(0,0,0,0.06)',
  },
};

export const headerBoxSx: SxProps<Theme> = {
  width: '224px',
  // match the TopBar toolbar height so the logo/title align on the same baseline
  height: '56px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  pl: '24px',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'rgba(0,0,0,0.06)',
  opacity: 1,
};

export const logoImgSx: SxProps<Theme> = { width: '28px', height: '28px', opacity: 1, alignSelf: 'center', objectFit: 'contain' };

export const titleSx: SxProps<Theme> = {
  fontFamily: 'against, Arial, sans-serif',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '16.89px',
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#143133',
  opacity: 1,
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
};

export const listSx: SxProps<Theme> = { mt: 3, pl: 2 };

export const listItemWrapperSx: SxProps<Theme> = { mb: 1 };

export const listItemButtonSelectedSx: SxProps<Theme> = {
  position: 'relative',
  bgcolor: '#EFF6FF',
  borderRadius: 0,
  width: '199px',
  height: '39.5px',
  pl: 1,
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
};

export const listItemButtonSx: SxProps<Theme> = {
  position: 'relative',
  width: '199px',
  height: '39.5px',
  borderRadius: 0,
  pl: '12px',
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
};

export const leftLineSx: SxProps<Theme> = {
  position: 'absolute',
  left: 0,
  top: '7.75px',
  width: '3px',
  height: '24px',
  bgcolor: '#39A9B1',
  borderTopRightRadius: '16777200px',
  borderBottomRightRadius: '16777200px',
  opacity: 1,
};

export const iconImgSx: SxProps<Theme> = { width: 20, height: 20 };

export const listItemTextTypographySx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
};

export const userBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  width: '224px',
  height: '82px',
  pt: '17px',
  pr: '12px',
  pl: '12px',
  opacity: 1,
  borderTop: '1px solid rgba(0,0,0,0.06)',
  boxSizing: 'border-box',
};

export const userNameSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0px',
  color: '#111827',
};

export const userRoleSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '10px',
  lineHeight: '15px',
  letterSpacing: '0.12px',
  color: 'text.secondary',
};
